import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key_here'
);

const GOLD = '#C9A84C';
const BG_DARK = '#1a1a1a';
const TEXT_PRIMARY = '#F5F0E8';
const TEXT_MUTED = '#d1d5db';

/** Shared Stripe Elements appearance — matches site dark theme */
export const STRIPE_APPEARANCE = {
  theme: 'night',
  labels: 'above',
  variables: {
    colorPrimary: GOLD,
    colorBackground: BG_DARK,
    colorText: TEXT_PRIMARY,
    colorTextSecondary: TEXT_MUTED,
    colorTextPlaceholder: '#6b7280',
    colorDanger: '#f87171',
    borderRadius: '12px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  },
};

export const STRIPE_PAYMENT_ELEMENT_OPTIONS = {
  layout: 'tabs',
  wallets: {
    applePay: 'never',
    googlePay: 'never',
  },
};

export default stripePromise;
